import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';
import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import UserManagementForm from '../components/UserManagementForm';

const UserManagementEditPage: React.FC = () => {
  const [t] = useTranslation('');
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <>
      <div className="header-top">
        <h2 className='title flex'>
          <span className='pi pi-arrow-left text-[20px] text-gray-500 cursor-pointer' onClick={() => navigate(PATH.user_management)}></span>
          <span className='ml-3'>
            {t('user_management.title')}
          </span>
        </h2>
      </div>
      <UserManagementForm id={Number(id)} />
    </>
  )
}

export default UserManagementEditPage;